import Api from "@/service/api";
// import { Captcha, VerifyType } from "./enum";
// import { CaptchaInterface } from "./interface";

// uuid
export async function getDeviceId(params: {} = {}) {
  return Api.request({
    url: "/member/tourists/gen/id",
    params,
  });
}

// 获取运费
export async function getShippingFeeConf<T>(data: {} = {}) {
  return Api.request<T>({
    url: "/express/getShippingFeeConf",
    method: "POST",
    data: { ...data }
  });
}

// 根据类型的首页卡片内容
export async function getCardContentsByType<T>(data: string[] = []) {
  return Api.request<T>({
    url: "/index/card-contents-by-type",
    method: "POST",
    data
  });
}
